import { render, staticRenderFns } from "./reference-number.vue?vue&type=template&id=1aad0358"
import script from "./reference-number.vue?vue&type=script&lang=js"
export * from "./reference-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports